import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledProjectWorkingDays} from '@/features/projects/components/project-form/project-expiration-date-fields/style'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {useWorkingDays} from '@/features/projects/hooks/useWorkingDays'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectWorkingDaysSchema = ProjectFieldsSchema.pick({
    startDate: true,
    expirationDate: true,
    durationDays: true
})
type ProjectWorkingDaysSchema = z.infer<typeof ProjectWorkingDaysSchema>

export const ProjectWorkingDays = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectWorkingDaysSchema>()

    const startDate = useWatch({control, name: 'startDate'})
    const expirationDate = useWatch({control, name: 'expirationDate'})
    const durationDays = useWatch({control, name: 'durationDays'})

    const actualDays = useWorkingDays({
        startDate: startDate ?? null,
        expirationDate: expirationDate ?? null,
        durationDays: durationDays ?? undefined
    })

    return (
        <Flexbox direction="column" gap={1.5}>
            <Text palette="neutral" shade="500" size="textSm">
                {t('projects:working_days')}
            </Text>
            <StyledProjectWorkingDays palette="neutral" shade="950" weight="500" size="textSm">
                {actualDays || '-'}
            </StyledProjectWorkingDays>
        </Flexbox>
    )
}
